module.exports = __webpack_public_path__ + "img/dinkenclave-8.5a82a89b.jpeg";